import Axios from 'axios';

export default {
  getStudents(search, page) {
    return Axios.get('/admin/students', { params: { search, page } }).then(({ data }) => data);
  },

  getStudent(studentId) {
    return Axios.get(`/admin/students/${studentId}`).then(({ data }) => data);
  },

  saveStudentData(student) {
    return Axios.put(`/admin/students/${student.id}`, { ...student })
      .then(({ data }) => data);
  },

  sendHsms(file, templateName) {
    const form = new FormData();
    const headers = { 'Content-Type': 'multipart/form-data' };

    form.append('spreadsheet', file);
    form.append('template_name', templateName);

    return Axios.post('/admin/students/send_hsms', form, { headers });
  },
};
